import { render, staticRenderFns } from "./SettingsEstablishment.vue?vue&type=template&id=0a8f4e13&scoped=true&"
import script from "./SettingsEstablishment.vue?vue&type=script&lang=js&"
export * from "./SettingsEstablishment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8f4e13",
  null
  
)

export default component.exports